export default __webpack_public_path__ + "static/gw2-icon-advanced-combat-f29e8167d683f56e3cd9303f04b29a15.png";